export enum Color {
  DEEP_SKY_BLUE = '#336699',
  SLATE_GRAY = '#2f4858',
  DEEP_INDIGO = '#392061',
  BRICK_RED = '#A4303F',
  PLUM_PURPLE = '#822E81',
  MIDNIGHT_PURPLE = '#3d314a',
  STEEL_BLUE = '#445E93',
  EARTH_BROWN = '#96705b',
  DUSTY_ROSE = '#ab8476',
  NEON_PINK = '#ff4d80',
  BRIGHT_CORAL = '#ff3e41',
  EGGPLANT_PURPLE = '#4c3549',
  OCEAN_BLUE = '#2274a5',
  TANGERINE = '#f75c03',
  SUNNY_YELLOW = '#f1c40f',
  RASPBERRY = '#d90368',
  EMERALD_GREEN = '#00cc66',
  MUTED_AQUA = '#8ab0ab',
  SKY_BLUE = '#6CA6C1',
  LAVENDER_PURPLE = '#7D5BA6',
  FOREST_GREEN_DARK = '#26413c',
  WINE_PURPLE = '#684756',
  ROSEWOOD = '#883955',
  CLOUDY_BLUE = '#7c98b3',
  BURNT_SIENNA = '#D36135',
  SLATE_BLUE_GRAY = '#536b78',
  PEWTER_BLUE = '#95afc0',
  CHERRY_RED = '#eb4d4b',
  PUMPKIN_ORANGE = '#f0932b',
  FRESH_GREEN = '#6ab04c',
  LILAC_PINK = '#e056fd',
  PERIWINKLE_BLUE = '#888dce',
  DEEP_MAROON = '#6a1f35',
  ROYAL_BLUE = '#516AF2',
  GOLDEN_BRONZE = '#D4AF37',
  BLACK = '#000000',
  COPPER_BROWN = '#b1752e',
  SPICY_RED = '#C8352F',
  APRICOT_ORANGE = '#EE964A',
  GOLD_YELLOW = '#fbc531',
  NIGHT_SKY_BLUE = '#30336b'
}

// new palette made by Saeideh - to replace the old one
export enum ColorV2 {
  BRIGHT_CORAL = '#FF3E41',
  EMERALD_GREEN = '#00CC66',
  LILAC_PINK = '#E056FD',
  PUMPKIN_ORANGE = '#F0932B',
  ELECTRIC_TEAL = '#00B8D4',
  RASPBERRY = '#D90368',
  FRESH_GREEN = '#6AB04C',
  MIDNIGHT_PURPLE = '#3D314A',
  GOLD_YELLOW = '#FBC531',
  BRIGHT_SKY_BLUE = '#0099FF',
  CHERRY_RED = '#EB4D4B',
  FOREST_GREEN_DARK = '#26413C',
  NEON_PINK = '#FF4D80',
  GOLDEN_BRONZE = '#D4AF37',
  PERIWINKLE_BLUE = '#888DCE',
  SPICY_RED = '#C8352F',
  VIBRANT_CYAN = '#00D9C0',
  PLUM_PURPLE = '#822E81',
  APRICOT_ORANGE = '#EE964A',
  NIGHT_SKY_BLUE = '#30336B',
  ELECTRIC_LIME = '#AAFF00',
  BRICK_RED = '#A4303F',
  LAVENDER_PURPLE = '#7D5BA6',
  TANGERINE = '#F75C03',
  DODGER_BLUE = '#1E90FF',
  ROSEWOOD = '#883955',
  SUNNY_YELLOW = '#F1C40F',
  EGGPLANT_PURPLE = '#4C3549',
  DARK_TURQUOISE = '#00CED1',
  BURNT_SIENNA = '#D36135',
  WINE_PURPLE = '#684756',
  LIME_GREEN = '#32CD32',
  COPPER_BROWN = '#B1752E',
  DEEP_PINK = '#FF1493',
  DEEP_INDIGO = '#392061',
  BRIGHT_GOLD = '#FFD700',
  DEEP_MAROON = '#6A1F35',
  VIVID_TANGELO = '#FF6B35',
  AMETHYST_PURPLE = '#9B59B6',
  LIGHT_SEA_GREEN = '#20B2AA',
  DARK_ORANGE = '#FF8C00'
}


export function hexToRgb(hex: string): string {
  const result: RegExpExecArray | null = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return hex;
  return `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)})`;
}